import { render } from "./infoList.vue?vue&type=template&id=3e15d48a&scoped=true&ts=true"
import script from "./infoList.vue?vue&type=script&lang=ts"
export * from "./infoList.vue?vue&type=script&lang=ts"

import "./infoList.vue?vue&type=style&index=0&id=3e15d48a&scoped=true&lang=less"

import exportComponent from "/workspace/source-code/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e15d48a"]])

export default __exports__